import { createSlice } from "@reduxjs/toolkit";

const SESSION_KEY = "globalJoyrideSessionClosed";
const COMPLETED_TOURS_KEY = "completedTours";

const initialState = {
  run: false,
  stepIndex: 0,
  isStepValid: false,
  steps: [],
  activeTour: null,
  target: null,

  // 👇 session control (rehydrate from sessionStorage)
  sessionClosed: sessionStorage.getItem(SESSION_KEY) === "true",

  // 👇 completed tours (rehydrate from localStorage)
  completedTours: JSON.parse(localStorage.getItem(COMPLETED_TOURS_KEY)) || [],

  formValues: {          // ✅ ADD
    subjectName: "",
    teacherName: "",
    teacherQualification: "",
    className: "",
  },
};

const globalJoyrideSlice = createSlice({
  name: "globalJoyride",
  initialState,
  reducers: {
    // ================= START TOUR =================
    startTour: (state, action) => {
      if (state.sessionClosed) return; // 🚫 block if closed for session

      state.run = true;
      state.steps = action.payload.steps;
      state.stepIndex = 0;
      state.activeTour = action.payload.name || null;
      state.target = null;
    },

    // ================= ENGINE =================
    nextStep: (state, action) => {
      state.stepIndex = action.payload;
    },

    setRun: (state, action) => {
      state.run = action.payload;
    },

    setSteps: (state, action) => {
      state.steps = action.payload;
    },


    setStepIndex: (state, action) => {
      state.stepIndex = action.payload;
    },

    setTarget: (state, action) => {
      state.target = action.payload;
    },

    setStepValid: (state, action) => {
      state.isStepValid = action.payload;
    },

    setPendingNavigation: (state, action) => {
      state.pendingNavigation = action.payload;
    },


    // ================= STOP TOUR =================
    stopTour: (state) => {
      state.run = false;
      state.stepIndex = 0;
      state.steps = [];
      state.target = null;
      state.activeTour = null;
    },

    // ================= SESSION CONTROL =================
    closeTourForSession: (state) => {
      state.sessionClosed = true;   // redux
      state.run = false;            // stop tour
      sessionStorage.setItem(SESSION_KEY, "true"); // persist for refresh
    },

    resetTourSession: (state) => {
      state.sessionClosed = false;
      sessionStorage.removeItem(SESSION_KEY); // allow tour again
    },

    // ================= FORM VALUES (✅ ADD) =================
    setFormValue: (state, action) => {
      const { key, value } = action.payload;
      state.formValues[key] = value;
    },

  },
});

export const {
  startTour,
  nextStep,
  setRun,
  setStepIndex,
  setTarget,
  stopTour,
  setSteps,
  setStepValid,
  closeTourForSession,
  resetTourSession,
  setFormValue,
  setPendingNavigation
} = globalJoyrideSlice.actions;

export default globalJoyrideSlice.reducer;
